import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=7a4c08f2&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=7a4c08f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c08f2",
  null
  
)

export default component.exports